import { createSelector } from '@reduxjs/toolkit';

import { CountryISOCodes } from 'common/countries';
import { formatPhoneNumber } from 'utils/phone';
import { RootState } from 'state/store';

import { ITheme } from './themeSlice';

export const getRoot = (state: RootState): ITheme => state.theme;
export const getProfile = (state: RootState) => state.profile;

export const getTheme = createSelector([getRoot], ({ theme }) => theme);

export const getIsLoading = createSelector(
  [getRoot],
  ({ isLoading }) => isLoading,
);

export const getDomain = createSelector([getRoot], ({ domain }) => domain);

export const getTenant = createSelector([getRoot], ({ tenant }) => tenant);

export const getTenantPhoneNumber = createSelector(
  [getRoot, getProfile],
  ({ tenant }, { businessAddress }) => {
    const { telephoneNumbers } = tenant;

    const phone =
      telephoneNumbers.find(
        ({ countryIsoCode }) =>
          countryIsoCode === businessAddress?.countryIsocode,
      ) ??
      telephoneNumbers.find(
        ({ countryIsoCode }) => countryIsoCode === CountryISOCodes.USA,
      );

    if (!phone) {
      return '';
    }

    return formatPhoneNumber(
      `${phone.countryCallingCode}${phone.telephoneNumber}`,
    );
  },
);
